import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { StatusBadge } from './StatusBadge';

interface TwoFactorRowProps {
  icon: LucideIcon;
  title: string;
  isOn: boolean;
  description: string;
  action: ReactNode;
  /** The setup steps or the confirmation, opening under the row. */
  children?: ReactNode;
}

/** One second factor in the Two-factor card: what it is, whether it's on, and the switch for it. */
export function TwoFactorRow({ icon: Icon, title, isOn, description, action, children }: TwoFactorRowProps) {
  return (
    <li className="py-4">
      <div className="flex items-start gap-3">
        <div className="grid size-9 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary ring-1 ring-primary/20">
          <Icon className="size-4.5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h3 className="text-sm font-semibold text-fg">{title}</h3>
            <StatusBadge isOn={isOn} label={isOn ? 'On' : 'Off'} />
          </div>
          <p className="mt-0.5 text-sm text-muted">{description}</p>
        </div>
        <div className="shrink-0">{action}</div>
      </div>
      {children}
    </li>
  );
}
